import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/website/src/components/DepartmentComponents/DetailesPageComponents/DepartmentDetails/DepartmentDetailes.tsx");
